import { UserState } from "../../../hooks/useUser";
import { updateAgency } from "../../../networkRequest/agenciesService";
import { Agency } from "../../../utils/types";
import { uploadImage } from "../../../networkRequest/uploadImageService";
import {
  OfficialData
} from '../../../networkRequest/officialsService';

export type UserDetailData = {
  official: OfficialData
};

export const updateAgencyLogo = async (user: UserState, file: File, agencyId: string | number) => {
  const { data: cloudinaryData, error: cloudinaryError } = await uploadImage({
    accessToken: user.accessToken,
    folder: `${agencyId}/agency_logo`,
    file
  })

  if (cloudinaryData) {
    const agencyUpdate = { id: agencyId, logo_url: cloudinaryData.secure_url }
    const { data, error} = await updateAgency(user.accessToken, agencyUpdate);

    if (data) return { data };
    if (error) return { error };
  } else if (cloudinaryError) {
    return { error: cloudinaryError }
  }

  return { error: 'Failed to update agency.'}
}

export const updateAgencyInfo = async (user: UserState, updatedAgencyInfo: Partial<Agency>) => {
  const { data, error } = await updateAgency(user.accessToken, updatedAgencyInfo);

  if (data) return { data };
  if (error) return { error };
}